"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'recording.process.failed': 'No se pudo procesar la grabación',
};
